import { type ReadableStore, deriveStore } from '@frontend/viewer-core';

import type { DxfSessionState, OverlayKey, OverlayState } from './types';

const NO_HIDDEN_LAYERS: ReadonlySet<number> = new Set();

/**
 * The hidden layers as drawn: the user's choice, except while viewing
 * interrogation results, when every layer is drawn.
 *
 * Derived rather than written so leaving the mode gives the user's own
 * visibility back without anything having to remember it.
 */
export const createDrawnHiddenLayers = (
  state: ReadableStore<DxfSessionState>,
): ReadableStore<ReadonlySet<number>> =>
  deriveStore(state, (current) =>
    current.mode === 'interrogation' ? NO_HIDDEN_LAYERS : current.hiddenLayers,
  );

const isSameOverlays = (a: OverlayState, b: OverlayState) =>
  (Object.keys(a) as OverlayKey[]).every((key) => a[key] === b[key]);

/**
 * The display toggles as drawn: the user's choice, except while viewing
 * interrogation results, when the drawing is one neutral colour with no role
 * colouring, so only the highlights stand out. The measurement and annotation
 * toggles are the user's either way.
 */
export const createDrawnOverlays = (
  state: ReadableStore<DxfSessionState>,
): ReadableStore<OverlayState> =>
  deriveStore(
    state,
    (current) =>
      current.mode === 'interrogation'
        ? {
            ...current.overlays,
            layerColoring: false,
            mappingColoring: false,
          }
        : current.overlays,
    isSameOverlays,
  );
